import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import Overlay from 'react-overlay-component';
import { useCombobox } from 'downshift';
import common from '../../common/common';
import { get } from '../../common/httpService';
import useFocus from '../../hooks/useFocus';
import translateService from '../../common/translateService';
import JSportAutocompleteResults from './JSportAutocompleteResults.jsx';
import { isEmpty } from 'lodash';

import './JSportAutocomplete.scss';

function JSportAutocomplete({ searchurl }) {
    const MINIMUM_CHARS_FOR_SEARCH = 3;
    const searchplaceholdertext = translateService.get('common.search');
    const [isOpenOverlay, setOverlay] = useState(false);
    const [inputRef, setFocus] = useFocus(null, 120);

    const closeOverlay = () => {
        setOverlay(false);
        setInputValue('');
        document
            .getElementsByClassName('container')[0]
            .classList.remove('search-open');
    };
    const emptyData = {
        products: [],
        totalProducts: 0,
        url: '',
        brands: [],
        otherBrands: 0,
        categories: [],
        otherCategories: 0,
    };
    const [itemsSet, setitemsSet] = useState(emptyData);
    const sanitizeForIos = (inputValue) => {
        //CHARS FOR TEST: ‘’“”–—‒-‐−
        // Open-quotes: http://www.fileformat.info/info/unicode/category/Pi/list.htm
        inputValue = inputValue.replace(/[\u2018]/g, "'");
        inputValue = inputValue.replace(/[\u201b]/g, "'");
        inputValue = inputValue.replace(/[\u201c]/g, '"');
        inputValue = inputValue.replace(/[\u201f]/g, '"');
        // Close-quotes: http://www.fileformat.info/info/unicode/category/Pf/list.htm
        inputValue = inputValue.replace(/[\u2019]/g, "'");
        inputValue = inputValue.replace(/[\u201d]/g, '"');
        // Primes: http://www.fileformat.info/info/unicode/category/Po/list.htm
        inputValue = inputValue.replace(/[\u2032]/g, "'");
        inputValue = inputValue.replace(/[\u2033]/g, '"');
        inputValue = inputValue.replace(/[\u2035]/g, "'");
        inputValue = inputValue.replace(/[\u2036]/g, '"');
        // iOS 11 also replaces dashes with em-dash
        // and "--" with en-dash
        inputValue = inputValue.replace(/[\u2014]/g, '-');
        inputValue = inputValue.replace(/[\u2013]/g, '-');
        return inputValue;
    };
    const getResults = async (inputValue) => {
        return inputValue.length >= MINIMUM_CHARS_FOR_SEARCH
            ? await get({
                  url:
                      'productbrowse/searchautocomplete?term=' +
                      encodeURIComponent(
                          sanitizeForIos(inputValue.trimEnd().trimStart())
                      ),
              })
            : emptyData;
    };

    const productsFound = itemsSet.products;
    const {
        inputValue,
        highlightedIndex,
        isOpen,
        getMenuProps,
        getInputProps,
        getComboboxProps,
        getItemProps,
        setInputValue,
        toggleMenu,
    } = useCombobox({
        items: productsFound,
        circularNavigation: false,
        onInputValueChange: async ({ inputValue }) => {
            if (!inputValue) {
                setitemsSet((prevState) => ({
                    ...prevState,
                    products: [],
                }));
                return;
            }
            if (inputValue.length >= MINIMUM_CHARS_FOR_SEARCH) {
                let debouncedFunc = _.debounce(async () => {
                    const result = await getResults(inputValue);
                    setitemsSet(result);
                }, 200);
                debouncedFunc();
            }
        },
    });

    useEffect(() => {
        let el = document.getElementById('hbl-live-chat-wrapper');
        if (isOpenOverlay) {
            if (el) el.style = 'display:none';
        } else {
            if (el) el.style = 'display:block';
        }

        let dropdown0 = document.getElementById('downshift-0-menu');

        if (dropdown0) {
            dropdown0.style.width =
                document
                    .querySelector('#search-input-container #s')
                    .getBoundingClientRect().width + 'px';
        }

        if (common.getSite() === 'runkd') {
            let dropdown1 = document.getElementById('downshift-1-menu');
            if (dropdown1) {
                dropdown1.style.width =
                    document
                        .querySelector(
                            '.grid_icons-container #search-input-container #s'
                        )
                        .getBoundingClientRect().width + 'px';
            }
        }
    }, [isOpenOverlay]);

    const changeOrderDropdownZIndex = (open) => {
        var items = document.getElementsByClassName(
            'products-and-filters-container'
        );

        if (items != null && items.length > 0) {
            if (open) {
                items[0].classList.add('search-open');
            } else {
                items[0].classList.remove('search-open');
            }
        }
    };
    return (
        <div
            className={
                common.getSite() === 'lordgun'
                    ? 'jsport-autocomplete'
                    : `jsport-autocomplete ${_.toLower(common.getSite())}`
            }>
            <a
                title='Search'
                className='search-icon-link'
                onClick={(e) => {
                    e.preventDefault();
                    setInputValue('');
                    setOverlay(true);
                    changeOrderDropdownZIndex(true);
                    setFocus(true);
                    // setTimeout(function () {
                    //   inputRef.current.focus();
                    // }, 20);
                }}>
                <img
                    src={common.contentFromCdn({
                        path: '/content/img/magnifying_glass_icon.svg',
                        keepUrlAsIs: false,
                    })}
                    type='image/svg+xml'
                    alt='search'
                />
            </a>
            <Overlay
                configs={{
                    animate: true,
                    clickDismiss: true,
                    escapeDismiss: true,
                    // focusOutline: false,
                    contentClass:
                        productsFound &&
                        productsFound.length > 0 &&
                        inputValue.length > MINIMUM_CHARS_FOR_SEARCH
                            ? 'container overlay-content results-visible'
                            : 'container overlay-content',
                }}
                isOpen={isOpenOverlay}
                closeOverlay={closeOverlay}
                showCloseIcon={false}
                tabIndex='-1'>
                <div
                    id='search-input-container'
                    {...getComboboxProps({})}
                    style={
                        isEmpty(inputValue)
                            ? { marginBottom: '2em' }
                            : { marginBottom: '0' }
                    }>
                    <div
                        style={{
                            display: 'flex',
                            width: '100%',
                            height: '98%',
                            justifyContent: 'center',
                        }}>
                        <div
                            style={{
                                display: 'flex',
                            }}>
                            <a
                                title='Search'
                                className='search-icon-link'
                                style={{ position: 'relative', left: '30px' }}
                                onClick={() => {
                                    const sanitizeForIos = (inputValue) => {
                                        //CHARS FOR TEST: ‘’“”–—‒-‐−
                                        // Open-quotes: http://www.fileformat.info/info/unicode/category/Pi/list.htm
                                        inputValue = inputValue.replace(
                                            /[\u2018]/g,
                                            "'"
                                        );
                                        inputValue = inputValue.replace(
                                            /[\u201b]/g,
                                            "'"
                                        );
                                        inputValue = inputValue.replace(
                                            /[\u201c]/g,
                                            '"'
                                        );
                                        inputValue = inputValue.replace(
                                            /[\u201f]/g,
                                            '"'
                                        );
                                        // Close-quotes: http://www.fileformat.info/info/unicode/category/Pf/list.htm
                                        inputValue = inputValue.replace(
                                            /[\u2019]/g,
                                            "'"
                                        );
                                        inputValue = inputValue.replace(
                                            /[\u201d]/g,
                                            '"'
                                        );
                                        // Primes: http://www.fileformat.info/info/unicode/category/Po/list.htm
                                        inputValue = inputValue.replace(
                                            /[\u2032]/g,
                                            "'"
                                        );
                                        inputValue = inputValue.replace(
                                            /[\u2033]/g,
                                            '"'
                                        );
                                        inputValue = inputValue.replace(
                                            /[\u2035]/g,
                                            "'"
                                        );
                                        inputValue = inputValue.replace(
                                            /[\u2036]/g,
                                            '"'
                                        );
                                        // iOS 11 also replaces dashes with em-dash
                                        // and "--" with en-dash
                                        inputValue = inputValue.replace(
                                            /[\u2014]/g,
                                            '-'
                                        );
                                        inputValue = inputValue.replace(
                                            /[\u2013]/g,
                                            '-'
                                        );
                                        return inputValue;
                                    };
                                    const searchParameter =
                                        encodeURIComponent(
                                            sanitizeForIos(
                                                inputValue.trimStart().trimEnd()
                                            )
                                        ) || '';

                                    window.location.href =
                                        searchurl + '?s=' + searchParameter;
                                    return false;
                                }}>
                                <img
                                    src={common.contentFromCdn({
                                        path: '/content/img/magnifying_glass_icon.svg',
                                        keepUrlAsIs: false,
                                    })}
                                    type='image/svg+xml'
                                    alt='search'
                                    style={{ top: '2px' }}
                                />
                            </a>

                            <input
                                tabIndex='-1'
                                autoComplete='off'
                                {...getInputProps({
                                    ref: inputRef,

                                    onKeyDown: (event) => {
                                        // event.preventDefault();
                                        if (event.key === 'Enter') {
                                            const sanitizeForIos = (
                                                inputValue
                                            ) => {
                                                //CHARS FOR TEST: ‘’“”–—‒-‐−
                                                // Open-quotes: http://www.fileformat.info/info/unicode/category/Pi/list.htm
                                                inputValue = inputValue.replace(
                                                    /[\u2018]/g,
                                                    "'"
                                                );
                                                inputValue = inputValue.replace(
                                                    /[\u201b]/g,
                                                    "'"
                                                );
                                                inputValue = inputValue.replace(
                                                    /[\u201c]/g,
                                                    '"'
                                                );
                                                inputValue = inputValue.replace(
                                                    /[\u201f]/g,
                                                    '"'
                                                );
                                                // Close-quotes: http://www.fileformat.info/info/unicode/category/Pf/list.htm
                                                inputValue = inputValue.replace(
                                                    /[\u2019]/g,
                                                    "'"
                                                );
                                                inputValue = inputValue.replace(
                                                    /[\u201d]/g,
                                                    '"'
                                                );
                                                // Primes: http://www.fileformat.info/info/unicode/category/Po/list.htm
                                                inputValue = inputValue.replace(
                                                    /[\u2032]/g,
                                                    "'"
                                                );
                                                inputValue = inputValue.replace(
                                                    /[\u2033]/g,
                                                    '"'
                                                );
                                                inputValue = inputValue.replace(
                                                    /[\u2035]/g,
                                                    "'"
                                                );
                                                inputValue = inputValue.replace(
                                                    /[\u2036]/g,
                                                    '"'
                                                );
                                                // iOS 11 also replaces dashes with em-dash
                                                // and "--" with en-dash
                                                inputValue = inputValue.replace(
                                                    /[\u2014]/g,
                                                    '-'
                                                );
                                                inputValue = inputValue.replace(
                                                    /[\u2013]/g,
                                                    '-'
                                                );
                                                return inputValue;
                                            };
                                            event.nativeEvent.preventDownshiftDefault = true;

                                            window.location.href =
                                                highlightedIndex === -1
                                                    ? searchurl +
                                                      '?s=' +
                                                      encodeURIComponent(
                                                          sanitizeForIos(
                                                              event.currentTarget.value
                                                                  .trimStart()
                                                                  .trimEnd()
                                                          )
                                                      )
                                                    : productsFound[
                                                          highlightedIndex
                                                      ].url;
                                            return false;
                                        }
                                    },
                                    onFocus: (event) => {
                                        event.preventDefault();
                                        // toggleMenu();
                                    },
                                    onChange: (event) => {
                                        setFocus(true);
                                    },
                                })}
                                id='s'
                                name='s'
                                type='search'
                                placeholder={searchplaceholdertext}
                                className={
                                    productsFound && productsFound.length > 0
                                        ? 'ui-autocomplete-input results-visible'
                                        : 'ui-autocomplete-input'
                                }
                                style={{
                                    height: 'initial',
                                    display: 'block',
                                }}></input>
                            <span
                                className='close-icon'
                                onClick={() => closeOverlay()}>
                                ×
                            </span>
                        </div>
                    </div>
                </div>
                <JSportAutocompleteResults
                    inputValue={inputValue}
                    highlightedIndex={highlightedIndex}
                    products={itemsSet.products}
                    totalProducts={itemsSet.totalProducts}
                    url={itemsSet.url}
                    brands={itemsSet.brands}
                    otherBrands={itemsSet.otherBrands}
                    categories={itemsSet.categories}
                    otherCategories={itemsSet.otherCategories}
                    getMenuProps={getMenuProps}></JSportAutocompleteResults>
            </Overlay>
        </div>
    );
}

export default JSportAutocomplete;
